import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2f9ca244"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "job-info" }
const _hoisted_4 = { class: "job-info-item" }
const _hoisted_5 = { style: {"color":"white","text-align":"center"} }
const _hoisted_6 = { class: "job-info-item" }
const _hoisted_7 = { style: {"color":"white"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { style: {"color":"white"} }, "vacante/s", -1))
const _hoisted_9 = { class: "job-info-item" }
const _hoisted_10 = {
  key: 0,
  style: {"color":"white"}
}
const _hoisted_11 = {
  key: 1,
  style: {"text-align":"center"}
}
const _hoisted_12 = { style: {"color":"white"} }
const _hoisted_13 = { style: {"color":"white"} }
const _hoisted_14 = { class: "section" }
const _hoisted_15 = { class: "job-info" }
const _hoisted_16 = { style: {"color":"white","text-align":"center"} }
const _hoisted_17 = { style: {"color":"white","text-align":"center"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_25 = {
  key: 0,
  class: "candidature"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Recuerda tener tu perfil de empleo debidamente cumplimentado y actualizado.", -1))
const _hoisted_27 = {
  key: 1,
  class: "candidature"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Necesitas registrarte o acceder con tu cuenta para poder presentar tu candidatura a esta oferta. ¡Es gratis!", -1))
const _hoisted_29 = [
  _hoisted_28
]

import ProdevValidator from '@/components/auth/ProdevValidator.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { Ref, ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router';
import EmployService from '@/services/EmployService';
import CandidatureService from '@/services/CandidatureService';
import EmployInterface from '@/interfaces/EmployInterface'
import { useAuth } from '@/store/useAuth';
import { useToast } from '@/store/useToast';
import { Toast } from '@/interfaces/ToastInterface';
import router from '@/router';
import main from '@/data/main.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectDetailView',
  setup(__props) {

const store = useAuth()
const toast = useToast()
const loading = ref(false)
const loadingCandidature = ref(false)
const route = useRoute()
const employService = new EmployService()
const candidatureService = new CandidatureService()
const employ:Ref<any> = ref({})
const img = computed(() => 'url(' + employ.value.image_url + ')')
const id = ref()

onMounted(async () => {
    loading.value = true
    id.value = route.params.id

    employ.value = await employService.GetEmploy(id.value)
    loading.value = false
})

const addCandidature = async () => {
    if(!store.token)
    {
        return
    }
    loadingCandidature.value = true
    await candidatureService.AddCandidatureToEmploy(store.token,employ.value.id)
    toast.showToast("Tu candidatura se ha añadido. Puedes consultar su estado en la sección 'MIS CANDIDATURAS'", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);
    router.push({name: 'my-candidatures'});
    loadingCandidature.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createVNode(ProdevValidator),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "job-header",
              style: _normalizeStyle({ 'background-image': img.value })
            }, [
              _createElementVNode("h1", null, _toDisplayString(employ.value?.name), 1)
            ], 4),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_v_icon, {
                  name: "bi-briefcase-fill",
                  fill: "white",
                  scale: "3"
                }),
                _createElementVNode("p", _hoisted_5, _toDisplayString(employ.value?.category?.name), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_v_icon, {
                  name: "la-user-circle",
                  fill: "white",
                  scale: "3"
                }),
                _createElementVNode("p", _hoisted_7, _toDisplayString(employ.value?.amount) + " puesto/s", 1),
                _hoisted_8
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_v_icon, {
                  name: "hi-solid-location-marker",
                  fill: "white",
                  scale: "3"
                }),
                (employ.value.is_remote)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Remoto"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("p", _hoisted_12, _toDisplayString(employ.value?.location?.name), 1),
                      _createElementVNode("small", _hoisted_13, _toDisplayString(employ.value?.location?.country?.name), 1)
                    ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h3", null, [
                _createVNode(_component_v_icon, {
                  name: "gi-diploma",
                  fill: _unref(main).THIRD_COLOR,
                  scale: "1.5",
                  style: {"margin-right":"5px"}
                }, null, 8, ["fill"]),
                _createTextVNode("Certificaciones y "),
                _createVNode(_component_v_icon, {
                  name: "gi-skills",
                  fill: _unref(main).THIRD_COLOR,
                  scale: "1.2",
                  style: {"margin-right":"5px"}
                }, null, 8, ["fill"]),
                _createTextVNode("Soft-Skills Recomendadas")
              ]),
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employ.value.certifications, (certification) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "job-info-item",
                    key: certification.id
                  }, [
                    _createVNode(_component_v_icon, {
                      name: "gi-diploma",
                      fill: "white",
                      scale: "3"
                    }),
                    _createElementVNode("p", _hoisted_16, _toDisplayString(certification.name), 1)
                  ]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employ.value.skills, (skill) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "job-info-item",
                    key: skill.id
                  }, [
                    _createVNode(_component_v_icon, {
                      name: "gi-skills",
                      fill: "white",
                      scale: "3"
                    }),
                    _createElementVNode("p", _hoisted_17, _toDisplayString(skill.name), 1)
                  ]))
                }), 128))
              ])
            ]),
            _hoisted_18,
            _hoisted_19,
            _hoisted_20,
            _createElementVNode("div", {
              innerHTML: employ.value?.description
            }, null, 8, _hoisted_21),
            _hoisted_22,
            _hoisted_23,
            _hoisted_24,
            (_unref(store).token)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("button", { onClick: addCandidature }, "Presentar mi candidatura"),
                  _hoisted_26
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
          ]))
    ]),
    _: 1
  }))
}
}

})